"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./HttpError.js"),e=require("axios");class t extends r.HttpError{constructor(r,t){super(e.HttpStatusCode.NotFound,"Resource not found.",r,t)}}exports.NotFoundError=t;
//# sourceMappingURL=NotFoundError.js.map
